import React from "react"
import {serverSideTranslations} from "next-i18next/serverSideTranslations"
import NavBar from "../../components/navigation/NavBar"
import Footer from "../../components/footer/Footer"
import HowItWorks from "../../components/home/howItWorks/HowItWorks"
import KonzeptBanner from "../../components/konzept/KonzeptBanner"
import nextI18NextConfig from "../../next-i18next.config.js"
import {useTranslation} from "next-i18next"
import MbpHead from "../../components/head/MbpHead"
import {getPageData} from "../../pageData"
import {staticDataHowItWorks} from "../../components/home/howItWorks/contentData"
import {useRouter} from "next/router"
import BannerWithForm from "../../components/BannerWithForm/BannerWithForm"
import Typography from "../../components/reusable/Typography/Typography"
import HomeCatBoxes from "../../components/home/homeCatBoxes/HomeCatBoxes"

const CreditCheckPage = () => {
	const {t} = useTranslation()
	const {locale, query} = useRouter()
	const {slug} = query
	const title = t("MyBikePlan | Credit Check | Schweiz")
	const description = t("Du hast Fragen oder Anliegen zu unseren E-Bikes oder möchtest uns sonst etwas mitteilen? Schreib uns hier, wir freuen uns, von dir zu hören!")

	const pdfUrl = "/files/Terms_en.pdf"

	const dataHowItWorks = staticDataHowItWorks[locale]

	const typeformIds = {
		1: {de: "01HXXM72HD4DPNGRB7W3F2QDJY", fr: "01HYFKERGJJTN3YD5MYTMCD7CG"},
		2: {de: "01HPH98E0TX1GPDR6FE4J8G3PG", fr: "01HV64G5Q53F7PEH1ZS1M515GQ"},
		3: {de: "01J2B5GXA256TNYPH4YHQGMYVD", fr: "01J2KNWWHS7E26BJ7ZNS1MKGM0"},
		4: {de: "01J2B2XBMGG0HVAXPSNCX1AB6Y"}, // No 'fr' locale for slug 4
		5: {de: "01HMEERW0NYRNY4K6GM9VXXDK0", fr: "01JJ6PXAM0MDHAAXVFJFBS9B18"},
		6: {de: "01J8FNFTX54PT7Y4TV6PTJ64Y8", fr: "01J8FP4MRH3S753M08EANSETES"},
		7: {de: "01JRCREDQ7RNP8GGSMDRQ8FG5R", fr: "01JRCREDQ7RNP8GGSMDRQ8FG5R"}, // Same ID for both locales
		8: {de: "01JRWQ4H8ZQ5WB2ZGFZ55BZP0H", fr: "01JRWQ4H8ZQ5WB2ZGFZ55BZP0H"}, // Same ID for both locales
		default: {de: "01HXXM72HD4DPNGRB7W3F2QDJY", fr: "01HXXM72HD4DPNGRB7W3F2QDJY"}
	}

	const getTypeform = (slug, locale) => {
		const formId = typeformIds[slug]?.[locale] || typeformIds.default[locale]
		return (
			<>
				<div data-tf-live={formId}
					data-tf-inline-on-mobile
					style={{width: "100%"}}></div>
				<script src="//embed.typeform.com/next/embed.js"></script>
			</>
		)
	}

	return (
		<>
			<MbpHead>
				<title>{title}</title>
				<meta name="description"
					content={description} />
				<meta property="og:title"
					content={title} />
				<meta property="og:description"
					content={description} />
			</MbpHead>
			<NavBar />
			<main>
				<div className="my-md-5 py-md-5 mt-4 pb-5 mb-3 mb-md-0 pb-md-3">
					<BannerWithForm
						bannerTitle={t("creditcheck-eligible-for-financing-title")}
						listTitle={t("creditcheck-banner-list-title")}
						listItemOne={t("creditcheck-list-item-1")}
						listItemTwo={t("creditcheck-list-item-2")}
						listItemThree={t("creditcheck-list-item-3")}
						bgImageSrc={"/assets/images/credit-check.jpg"}
						typeform={getTypeform(slug, locale)}
					/>
				</div>
				<div className="pb-5 container">
					<KonzeptBanner isCreditCheckPage />
					<HomeCatBoxes />
				</div>

				<HowItWorks blockTilesHowItWorks={dataHowItWorks}
					hasOptionalText />
				<div className="my-5 pt-5 py-md-5 container">
					<Typography variant="bodyLgBold"
						semanticTag="span">{t("Hinweis")}: </Typography>
					<Typography variant="bodyLg"
						semanticTag="span">
						{t("notice-text")}
					</Typography>
					<a href={
						locale === "fr" ?
							"/files/Terms_CGV_MFG.pdf" :
							"/files/Terms_AGB_MFG.pdf"
					}
					className="ms-2"
					download
					>
						{locale === "fr" ? "CGV MFG" : "AGB MFG"}
					</a>
				</div>
			</main>
			<Footer />
		</>
	)
}

export async function getStaticPaths() {
	const slugs = ["1", "2", "3", "4", "5", "6", "7", "8"]
	const locales = ["de", "fr"]

	const paths = slugs.flatMap(slug =>
		locales.map(locale => ({
			params: {slug},
			locale
		}))
	)

	return {
		paths,
		fallback: false
	}
}

export async function getStaticProps({params, locale}) {
	return {
		props: {
			...(await getPageData(locale, [])),
			...(await serverSideTranslations(locale, ["common", "URL", "search", "filters"], nextI18NextConfig))
		}
	}
}

export default CreditCheckPage
